import type { FC, ReactNode } from "react";

import { enterKey, styles } from "@repo/helpers";

import { Button } from "../button";
import style from "./style.module.scss";

interface Props {
	children: ReactNode;
	/**
	 * Callback triggered when the user explicitly applies the filters via the Find button or pressing Enter.
	 * If not provided, the Find button is hidden and Enter handling is disabled by default to avoid breaking existing flows.
	 */
	onApply?: () => void;
	/** Controls rendering of the Find button. Defaults to true when onApply is provided. */
	showApplyButton?: boolean;
	/** The label for the apply button. Defaults to "Find". */
	applyLabel?: string;
	className?: string;
}

/** Put on a filter that should take two columns when the filter row is wide enough for two. */
export const filterSpanTwoClassName = style.spanTwo;

export const FiltersV2: FC<Props> = ({ children, className, onApply, showApplyButton, applyLabel = "Find" }) => {
	const renderButton = !!onApply && (showApplyButton ?? true);

	return (
		<div className={styles(style.root, className)} onKeyDown={enterKey(onApply)}>
			<div className={style.container}>{children}</div>
			{renderButton && (
				<div className={style.actions}>
					<Button color="green" type="button" onClick={onApply}>
						{applyLabel}
					</Button>
				</div>
			)}
		</div>
	);
};
